import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { error } from 'actions/notifications';
import styles from './ApplyBox.css';

class ApplyBox extends React.Component {
  constructor(props) {
    super(props);
    const { startDate, endDate } = this.props;
    this.state = {
      startDate: moment(startDate),
      endDate: moment(endDate),
      startDateText: moment(startDate).format('D/M/YYYY'),
      endDateText: moment(endDate).format('D/M/YYYY'),
    };
  }

  componentWillReceiveProps(props) {
    const isSameStartDate = moment(props.startDate).isSame(
      this.state.startDate,
      'days'
    );
    const isSameEndDate = moment(props.endDate).isSame(
      this.state.endDate,
      'days'
    );
    if (
      props.startDate &&
      props.endDate &&
      !(isSameEndDate && isSameStartDate)
    ) {
      this.setState({
        startDate: moment(props.startDate),
        endDate: moment(props.endDate),
        startDateText: moment(props.startDate).format('D/M/YYYY'),
        endDateText: moment(props.endDate).format('D/M/YYYY'),
      });
    }
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className="row">
          <div className="col-md-12">
            <form className="form-inline">
              <div className={`form-group ${styles['form-group']}`}>
                <input
                  type="text"
                  className={`form-control ${styles.input}`}
                  onChange={this._onChangeStartDate}
                  value={this.state.startDateText}
                />
              </div>
              <div className={`form-group ${styles['form-group']}`}>
                <input
                  type="text"
                  className={`form-control ${styles.input}`}
                  onChange={this._onChangeEndDate}
                  value={this.state.endDateText}
                />
              </div>
              <div className={`form-group ${styles['form-group']}`}>
                <button
                  className={`btn btn-primary btn-block ${styles['btn-apply']}`}
                  onClick={this._onClickApply}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  _onChangeStartDate = e => {
    this.setState({ startDateText: e.target.value });
  };

  _onChangeEndDate = e => {
    this.setState({ endDateText: e.target.value });
  };

  _onClickApply = e => {
    // we need this to prevent keep opening of dropdown
    // because the open state needs to be set manually (from onApply)
    e.preventDefault();
    e.stopPropagation();

    const { dispatch } = this.props;
    const { startDateText, endDateText } = this.state;
    const startDate = moment(startDateText, 'D/M/YYYY');
    const endDate = moment(endDateText, 'D/M/YYYY');

    // required to display timezone
    const endDateMessage = new Date(
      endDateText.split('/')[2],
      endDateText.split('/')[1] - 1,
      endDateText.split('/')[0]
    );
    const currentDateMessage = new Date();

    if (!startDate.isValid()) {
      dispatch(error('Invalid start date. Format must be D/M/YYYY'));
    } else if (!endDate.isValid()) {
      dispatch(error('Invalid end date. Format must be D/M/YYYY'));
    } else if (startDate.isAfter(endDate, 'days')) {
      dispatch(
        error(
          `Start date should be lower than equal end date (${endDateMessage.toString()})`
        )
      );
    } else if (startDate.isAfter(moment(), 'days')) {
      dispatch(
        error(
          `Start date should be lower than equal current date (${currentDateMessage.toString()})`
        )
      );
    } else if (Math.abs(startDate.diff(endDate, 'days')) > 365) {
      dispatch(error('Reports can only be shown for one year period or less'));
    } else {
      this.props.onApply({ startDate, endDate });
    }
  };
}

ApplyBox.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onApply: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  null,
  mapDispatchToProps
)(ApplyBox);
